import type { NavLinkProps } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

import { useOrganisationId } from 'hooks/context';

export const OrgNavLink = ({ children, to, ...props }: NavLinkProps) => {
  const organisationId = useOrganisationId();

  const pathname = (to as string).startsWith(`/org/${organisationId}`)
    ? to
    : `/org/${organisationId}${to}`;

  return (
    <NavLink to={pathname} {...props}>
      {children}
    </NavLink>
  );
};
